import { render, staticRenderFns } from "./ConfigurationLang.vue?vue&type=template&id=fced9a0e&scoped=true"
import script from "./ConfigurationLang.vue?vue&type=script&lang=js"
export * from "./ConfigurationLang.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationLang.vue?vue&type=style&index=0&id=fced9a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced9a0e",
  null
  
)

export default component.exports